export default {
  setAdminStoreList(state, data) {
    state.adminStoreList = data.list;
  },

  setAdminStoreInfo(state, data) {
    state.adminStoreInfo = data;
  },

  setCount: (state, count) => {
    state.count = count;
  },
  setTransaction: (state, transaction) => {
    state.transaction = transaction;
  },
  setSales: (state, sales) => {
    state.sales = sales;
  }
};
